import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SetPayCycleShoutPanel',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BarArrowButton, {
                flex: true,
                large: true,
                class: "linkAccounts",
                title: "Spending Analysis",
                href: "/#/setupspendinganalysis",
                bgImage: require('@/assets/bg/puzzle.png')
            }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "barArrowButtonSlotContent" }, [
                        _createElementVNode("a", { href: "/#/setupspendinganalysis" }, [
                            _createElementVNode("p", null, "You can set your pay cycle by clicking here to get the most out of Money Guided.")
                        ])
                    ], -1)
                ])),
                _: 1
            }, 8, ["bgImage"]));
        };
    }
});
